import { Link } from 'react-router-dom';
import { Button, EmptyState } from '../components/ui.js';

export function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 sm:px-6">
      <EmptyState
        title="That page does not exist"
        description="The link may be out of date, or the product may have been archived. The catalogue is the fastest way back."
        icon={
          <svg viewBox="0 0 24 24" className="size-10 text-subtle" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5m0 3h.01" strokeLinecap="round" />
          </svg>
        }
        action={
          <Link to="/">
            <Button variant="secondary">Back to the catalogue</Button>
          </Link>
        }
      />
    </div>
  );
}
